module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t('message.login_title')))]), _c('ErrorMsg', {
    attrs: {
      "backError": _vm.backendMsg
    },
    on: {
      "clearError": _vm.CloseError
    }
  }), _c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "lang": 'lang'
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "email"
    }
  }, [_c('Gtinput', {
    attrs: {
      "width": "290px",
      "type": "text",
      "placeholder": _vm.$t('message.email_placeholder'),
      "PreIcon": "email"
    },
    on: {
      "on-blur": function($event) {
        return _vm.checkemail()
      }
    },
    model: {
      value: (_vm.formValidate.email),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "email", $$v)
      },
      expression: "formValidate.email"
    }
  })], 1), (_vm.riskDetection) ? _c('div', {
    staticClass: "check_email"
  }, [_c('Gtinput', {
    attrs: {
      "width": "290px",
      "type": "text",
      "placeholder": _vm.$t('message.risk_detection_content'),
      "PreIcon": "lock"
    },
    model: {
      value: (_vm.secondCode),
      callback: function($$v) {
        _vm.secondCode = $$v
      },
      expression: "secondCode"
    }
  })], 1) : _vm._e(), _c('FormItem', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Gtinput', {
    attrs: {
      "width": "290px",
      "type": _vm.type,
      "placeholder": _vm.$t('message.password_placeholder'),
      "PreIcon": "lock"
    },
    model: {
      value: (_vm.formValidate.password),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "password", $$v)
      },
      expression: "formValidate.password"
    }
  }), _c('div', {
    staticClass: "eye-icon",
    on: {
      "click": _vm.handle
    }
  }, [_c('GtIcon', {
    staticClass: "icon-password-on",
    class: {
      'hide-opcity': _vm.type == 'password'
    },
    attrs: {
      "icon": "eye"
    }
  })], 1)], 1), _c('div', {
    staticClass: "captcha-wrapper"
  }, [_c('Captcha', {
    attrs: {
      "reSent": _vm.reSet,
      "email": _vm.formValidate.email,
      "CaptchaId": 'captchaIdLogin',
      "lang": _vm.$i18n.locale
    },
    on: {
      "reSentEvent": _vm.reSentEvents,
      "capError": _vm.captchaError
    }
  })], 1), _c('div', {
    staticClass: "keep-box"
  }, [_c('div', {
    staticClass: "keep-status"
  }, [_c('div', [_c('Checkbox', {
    attrs: {
      "label": _vm.$t('message.keeplogin')
    },
    model: {
      value: (_vm.rember),
      callback: function($$v) {
        _vm.rember = $$v
      },
      expression: "rember"
    }
  })], 1), _c('router-link', {
    attrs: {
      "to": {
        name: 'reset'
      },
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.forget")) + "?")])], 1)]), _c('div', {
    staticClass: "geetest-btn",
    class: {
      'disabled': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.loginSubmit('formValidate')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("message.sign")) + "\n        "), _c('i', {
    staticClass: "geetest-icons"
  }, [_vm._v("arrow_forward")])]), _c('div', {
    staticClass: "page-note"
  }, [_c('a', {
    attrs: {
      "href": _vm.$t('message.registerInfo_link'),
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.go_register_text')) + "\n        ")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9b420ce","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 661
// module chunks = 0